module.exports = __webpack_public_path__ + "static/img/fingerpost_express_8.20550c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_express_8.jpg
// module id = oQtx
// module chunks = 0